import { Typography } from 'antd'
import React from 'react'

const { Text } = Typography

const FormSection = ({
  label,
  children,
  helperTitle,
  helperDesc,
  required,
  className,
}) => (
  <div className={`form-section ${className || ''}`}>
    <label className="form-label">
      {label}
      {required && (
        <span style={{ color: '#F25A67', marginLeft: '4px' }}>*</span>
      )}
    </label>
    <div className="form-content-wrapper">
      {children}
      {helperTitle && (
        <div className="helper-box">
          <Text className="helper-title">{helperTitle}</Text>
          <Text className="helper-desc">{helperDesc}</Text>
        </div>
      )}
    </div>
  </div>
)

export default FormSection
